import type React from 'react';

import Button from 'components/partials/button/button';

import Icons from 'assets/icons';

interface MessageErrorItemProps {
  message: { content?: string };
  onRetry: () => void;
}

const MessageErrorItem = ({
  message,
  onRetry,
}: MessageErrorItemProps): React.JSX.Element => (
  <div className="flex justify-between items-center gap-3 w-fit max-w-[700px] bg-critical-50 px-4 py-3 rounded-md border border-critical-600 mb-5">
    <p className="text-critical-800">{message.content}</p>

    <Button
      size="sm"
      variant="reserve-outlined"
      className="text-critical-600 bg-white border-critical-600 !h-7"
      iconBefore={<Icons.Retry />}
      onClick={onRetry}
    >
      Retry
    </Button>
  </div>
);

export default MessageErrorItem;
